var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinusCircle = function SvgMinusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.563 13.313A.564.564 0 0 1 6 12.75v-1.5c0-.31.253-.562.563-.562h10.875c.309 0 .562.253.562.562v1.5c0 .31-.253.563-.562.563zM23.625 12c0 6.422-5.203 11.625-11.625 11.625S.375 18.422.375 12 5.578.375 12 .375 23.625 5.578 23.625 12m-2.25 0A9.37 9.37 0 0 0 12 2.625 9.37 9.37 0 0 0 2.625 12 9.37 9.37 0 0 0 12 21.375 9.37 9.37 0 0 0 21.375 12"
  })));
};
export default SvgMinusCircle;